import { render, staticRenderFns } from "./ExhibitionsForm.vue?vue&type=template&id=910ba126&"
import script from "./ExhibitionsForm.vue?vue&type=script&lang=js&"
export * from "./ExhibitionsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports